import '@swc/helpers';
import React__default, { useContext } from 'react';

const settingsDefaults = {
    thresholds: []
};
const StockIndicatorContext = /*#__PURE__*/ React__default.createContext({});
const useStockIndicator = ()=>useContext(StockIndicatorContext)
;
var StockIndicatorContext$1 = StockIndicatorContext;

export { StockIndicatorContext$1 as default, settingsDefaults, useStockIndicator };
//# sourceMappingURL=StockIndicatorContext.js.map
